import { cn } from "cn"

/** Indeterminate work, with an accessible label and a static reduced-motion state. */
function ActivityIndicator({ label = "Loading...", className }: { label?: string; className?: string }) {
  const colors = ["text-brand-teal", "text-brand-green", "text-brand-amber", "text-brand-red"]
  return (
    <span role="status" className={cn("inline-flex items-center justify-center", className)} data-slot="activity-indicator">
      <svg viewBox="0 0 40 40" className="size-9 animate-spin [animation-duration:var(--duration-rise)] motion-reduce:animate-none" aria-hidden="true">
        {Array.from({ length: 12 }, (_, i) => (
          <rect key={i} x="18.5" y="3" width="3" height="9" rx="1.5" fill="currentColor" opacity={(i + 1) / 12} transform={`rotate(${i * 30} 20 20)`} className={colors[Math.floor(i / 3)]} />
        ))}
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  )
}

export { ActivityIndicator }
